import React, { useState, useContext, useEffect, useCallback } from 'react';
import { useForm, FormProvider } from 'react-hook-form';

import DatosPersonales from '../DatosPersonales/DatosPersonales';
import Localizacion from '../Localizacion/Localizacion';
import Gratitude from '../Shared/Gratitude';
import SMSComp from '../SMS/SMSComp';

import TimeCompContext from '../../context/TimerCompContext';
import ViewContext from '../../context/ViewContext';
import PositionContext from '../../context/PositionContext';
import { useCurrentLocation } from '../../hooks/useCurrentLocation';
import Header from '../Header/Header';

function FormComp({ children }) {

    const methodSMS = useForm();
    const methods = useForm();
    const methodsLocalizacion = useForm();
    const [dataTimeContext, setdataTimeContext] = useState({ minutes: 5, seconds: 0 });
    const [dataView,] = useContext(ViewContext);
    const [, setPosition] = useContext(PositionContext);

    const pos = useCurrentLocation();
    const updatePosition = useCallback(
        (pos) => {
            setPosition(pos);
        },
        [setPosition],
    )

    useEffect(() => {
        updatePosition(pos);
    }, [updatePosition, pos])

    return (
        <>
            {dataView !== 'END' &&
                <>
                    <div id="titleFormulario" className='title'>
                        <span className='title_form'>Llena el formulario</span> <span className='title_text'>para <br /> transformar tu vida</span>
                    </div>
                    <Header />
                </>
            }

            {
                dataView === 'SMS' ?
                    (
                        <FormProvider {...methodSMS}>
                            <TimeCompContext.Provider value={[dataTimeContext, setdataTimeContext]}>
                                <SMSComp />
                            </TimeCompContext.Provider>
                        </FormProvider>
                    ) : null
            }
            {
                dataView === 'DP' ?
                    (
                        <FormProvider {...methods}>
                            <DatosPersonales />
                        </FormProvider>
                    ) : null
            }
            {
                dataView === 'LZ' ? (
                    <FormProvider {...methodsLocalizacion}>
                        <Localizacion />
                    </FormProvider>) : null
            }
            {
                dataView === 'END' && <Gratitude />
            }
            {children}
        </ >
    )
}

export default FormComp;
